export enum TwitterStandardEvent {
    SIGNED_UP = 'tw-o42un-oeeto'
};
